<template>
  <h3>Nova Publicidade</h3>
  <form ref="form" @submit.prevent="submitForm">
    <div v-for="field in fields" :key="field.key" class="row">
      <div v-if="field.type === 'select'" class="col-md-12">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <select v-model="registro[field.key]" class="ant-select ant-select-lg custom-select" required>
          <option v-for="option in field.options" :key="option.value" :value="option.value">{{ option.label }}</option>
        </select>
      </div>
      <div v-else-if="field.type === 'file'" class="col-md-12">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <input ref="file" :type="field.type" class="ant-input ant-input-lg" required />
      </div>
      <div v-else-if="field.key === 'dataFim'" class="col-md-12">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <input v-model="registro[field.key]" :min="registro.dataInicio" type="date" class="ant-input ant-input-lg" />
      </div>
      <div v-else class="col-md-12">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <input v-model="registro[field.key]" :type="field.type" class="ant-input ant-input-lg" required />
      </div>
    </div>
    <div class="spaced-container2">
      <a-button class="yellow-button" @click="voltar"> Voltar </a-button>
      <button type="submit" class="ant-btn ant-btn-primary" @click="cadastrar">Salvar</button>
    </div>
  </form>
</template>

<script>
import { createPublicidade } from '@/components/service/publicidadeService';
import { sendDocumentFileWs } from '@/utils/filews';
import { openNotification, typesNotification } from '@/utils/notifications';

export default {
  name: 'FormCadastrarPublicidade',
  data() {
    return {
      registro: {},
      fields: [
        { key: 'nome', label: 'Nome', type: 'text' },
        {
          key: 'tipo',
          label: 'Tipo',
          type: 'select',
          options: [
            { label: 'Vídeo', value: 'VIDEO' },
            { label: 'Banner', value: 'BANNER' },
          ],
        },
        { key: 'dataInicio', label: 'Data Início', type: 'date' },
        { key: 'dataFim', label: 'Data Fim', type: 'date' },
        { key: 'idArquivo', label: 'Arquivo', type: 'file' },
        {
          key: 'situacao',
          label: 'Status',
          type: 'select',
          options: [
            { label: 'Ativo', value: 'ATIVO' },
            { label: 'Inativo', value: 'INATIVO' },
          ],
        },
      ],
    };
  },
  methods: {
    async cadastrar() {
      if (this.$refs.form.checkValidity()) {
        const ini = new Date(this.registro.dataInicio);
        const fim = new Date(this.registro.dataFim);

        const resArquivo = await sendDocumentFileWs(this.$refs.file[0].files[0], 'PUBLICO', 'ssp');
        this.registro.idArquivo = resArquivo.data.id;
        this.registro.dataInicio = ini.setUTCHours(ini.getUTCHours() + 3);
        this.registro.dataFim = fim.setUTCHours(fim.getUTCHours() + 3);
        await createPublicidade(this.registro);
        this.voltar();
        openNotification(typesNotification.success, 'Publicidade criada com sucesso');
      }
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.yellow-button {
  background-color: #faad14;
  border-color: #faad14;
  color: white;
  margin-top: 10px;
}

.yellow-button:hover {
  background-color: #ffc53d;
  border-color: #ffc53d;
  color: white;
}
.spaced-container2 * {
  margin-top: 10px;
  margin-right: 10px;
}
.custom-select {
  width: 100%;
  height: 40px;
  font-size: 16px;
  padding: 8px 12px;
}
</style>
